/* eslint-disable jsdoc/require-jsdoc */
import type { SAFE_ANY } from "../types";

import chalk from "chalk";
import { default as _gradientString } from "gradient-string";

export const defaultColors = ["#F54180", "#338EF7"] as const;

const gradientString = _gradientString(...defaultColors);

const logPrefix = gradientString("Snack Money CLI:");

export type PrefixLogType = Extract<
  keyof typeof Logger,
  "error" | "gradient" | "info" | "log" | "warn" | "success"
>;

export class Logger {
  constructor() {}

  static log(...args: Parameters<typeof console.log>) {
    console.log(...args);
  }

  static info(...args: Parameters<typeof console.info>) {
    console.info(...args.map((item) => chalk.blue(item)));
  }

  static success(...args: Parameters<typeof console.info>) {
    console.info(...args.map((item) => chalk.green(item)));
  }

  static warn(...args: Parameters<typeof console.warn>) {
    console.warn(...args.map((item) => chalk.yellow(item)));
  }

  static error(...args: Parameters<typeof console.error>) {
    console.error(...args.map((item) => chalk.red(item)));
  }

  static grey(...args: Parameters<typeof console.log>) {
    console.log(...args.map((item) => chalk.gray(item)));
  }

  static gradient(
    content: string | number | boolean,
    // eslint-disable-next-line prettier/prettier
    options?: { colors?: tinycolor.ColorInput[] }
  ) {
    this.log(
      // eslint-disable-next-line prettier/prettier
      _gradientString(...(options?.colors ?? defaultColors))(String(content))
    );
  }

  static prefix(type: PrefixLogType, ...args: SAFE_ANY) {
    return this[type](logPrefix, ...args);
  }

  static newLine(lines?: number) {
    if (!lines) lines = 1;

    for (let i = 0; i < lines; i++) this.log();
  }
}
